export default __webpack_public_path__ + "static/media/cathodic2.21c8ad35.jpg";